/* Business-category <select> options (signup wizard, company settings). */
import { INDUSTRIES } from "../../domain/industry";

export const categoryOptions = (L: (en: string, ar: string) => string, placeholder: boolean): [string, string][] => [
  ...(placeholder ? [["", L("Select your business category…", "اختر نشاط منشأتك…")] as [string, string]] : []),
  ...INDUSTRIES.map((c): [string, string] => [c.key, L(...c.name)]),
];
